var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMove = function SvgMove(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Account-and-onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account--Settings-Personal-details-add-imge-repositioned",
    transform: "translate(-917.000000, -504.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(308.000000, 480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Move_1278790",
    transform: "translate(609.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "20.1804255 8.98956522 22.1719149 11.4495652 12.4697872 11.4495652 12.4697872 1.78434783 14.8774468 3.81913043 15.5285106 3.01565217 11.9591489 0 8.38978723 3.01565217 9.04085106 3.81913043 11.4485106 1.78434783 11.4485106 11.4495652 1.74893617 11.4495652 3.73787234 8.98956522 2.95148936 8.32434783 0 11.9713043 2.95148936 15.6182609 3.73787234 14.9530435 1.74893617 12.4930435 11.4485106 12.4930435 11.4485106 22.1582609 9.04085106 20.1234783 8.38978723 20.9269565 11.9591489 23.9426087 15.5285106 20.9269565 14.8774468 20.1234783 12.4697872 22.1582609 12.4697872 12.4930435 22.1693617 12.4930435 20.1804255 14.9530435 20.9668085 15.6182609 23.9182979 11.9713043 20.9668085 8.32434783"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/move.ef7928d1.svg";
export { ForwardRef as ReactComponent };